import React from 'react';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-black text-white">

      {/* Main content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16">
        
        {/* Header with Logo */}
        <header className="text-center mb-16">
          <div className="flex justify-center mb-8">
            <img 
              src="/ic_logo.png" 
              alt="AiS english Logo" 
              className="w-48 h-48 md:w-64 md:h-64 rounded-3xl shadow-2xl"
            />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">AiS english</h1>
          <p className="text-xl md:text-2xl text-white max-w-2xl mx-auto">Unlock the power of learning English with AiS english!</p>
        </header>

        {/* Contact Section */}
        <section className="mb-16">
          <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-center">Contact & Support</h2>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 text-center">
            <p className="text-lg text-white mb-6">
              For support, questions, or feedback, please contact us:
            </p>
            <a 
              href="mailto:phobosbag@gmail.com" 
              className="inline-flex items-center gap-3 text-base md:text-2xl text-[#F2AF3C] hover:opacity-80 transition-opacity"
            >
              <span className="text-3xl">✉️</span>
              <span className="break-all">phobosbag@gmail.com</span>
            </a>
          </div>
        </section>

        {/* Legal Links */}
        <section className="mb-16">
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12">
            <a 
              href="/terms.html" 
              className="text-lg text-[#F2AF3C] hover:opacity-80 transition-opacity underline underline-offset-4"
            >
              Terms of Service
            </a>
            <a 
              href="/privacy.html" 
              className="text-lg text-[#F2AF3C] hover:opacity-80 transition-opacity underline underline-offset-4"
            >
              Privacy Policy
            </a>
          </div>
        </section>

        {/* Address */}
        <section className="mb-8 text-center">
          <p className="text-white text-sm leading-relaxed">
            23433 Anza Ave<br />
            Torrance, California, 90505, USA
          </p>
        </section>

        {/* Footer */}
        <footer className="text-center text-gray-400 text-sm">
          <p className="text-white">© {new Date().getFullYear()} AiS english. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
